import React, { useRef, useState } from 'react';
import { ButtonGroup, ClickAwayListener, MenuItem, MenuList, Popper } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Icon } from '../icons';
import useStyles from './DropdownButton.styles';
import TextButton from './TextButton';

const DropdownButton = ({ label, options, disabled }) => {
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const anchorRef = useRef();

  const handleMenuItemClick = (event, index) => {
    options[index].onClick(event);
    setOpen(false);
  };

  return (
    <>
      <ButtonGroup ref={anchorRef}>
        <TextButton onClick={() => setOpen(!open)} disabled={disabled}>
          <div className={classes.label}>{label}</div>
          <Icon icon={!open ? 'expand_more' : 'expand_less'} />
        </TextButton>
      </ButtonGroup>

      <Popper className={classes.popper} open={open} anchorEl={anchorRef.current} placement="bottom-end">
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <MenuList className={classes.menu}>
            {options.map((option, index) => (
              <MenuItem
                className={classes.menuItem}
                disabled={option.disabled}
                key={option.label || String(index)}
                onClick={option.onClick ? (event) => handleMenuItemClick(event, index) : undefined}>
                {option.render ? option.render() : option.label}
              </MenuItem>
            ))}
          </MenuList>
        </ClickAwayListener>
      </Popper>
    </>
  );
};

DropdownButton.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  disabled: PropTypes.bool,
};

DropdownButton.defaultProps = {
  disabled: false,
};

export default React.memo(DropdownButton);
